
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import LandingHeader from "@/components/landing/LandingHeader";
import LandingForm from "@/components/landing/LandingForm";

const LandingPage = () => {
  const navigate = useNavigate();

  // Check for existing access data on component mount
  useEffect(() => {
    const accessData = localStorage.getItem('appAccess');
    if (accessData) {
      try {
        const parsedData = JSON.parse(accessData);
        if (parsedData.firstName && parsedData.lastName && parsedData.email && parsedData.country) {
          // User has already provided their information, redirect to home
          navigate('/home');
        }
      } catch (error) {
        console.error("Error parsing access data:", error);
      }
    }
  }, [navigate]);

  const handleAccessGranted = () => {
    navigate('/home');
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4">
      <div className="w-full max-w-md space-y-8 bg-white p-8 rounded-lg shadow-md">
        <LandingHeader />
        <LandingForm onAccessGranted={handleAccessGranted} />
      </div>
    </div>
  );
};

export default LandingPage;
